module.exports = __webpack_public_path__ + "img/jpCustomerService.36fd99a.webp";